var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"box",staticClass:"maxwidht"},[_vm._l((_vm.defaultImg),function(item,index){return _c('div',{key:index,staticClass:"defaultImg"},[_c('img',{attrs:{"src":item,"alt":""}})])}),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm.currentObj.company_info))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9bd16624","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/single.vue
// module id = null
// module chunks = 